module.exports = __webpack_public_path__ + "img/logo.f078cbb3.svg";